module.exports = __webpack_public_path__ + "img/ListaDePagadores-admin.31008798.svg";